import { useState, useEffect } from 'react';
import { ApiStatus } from '@src/constants/ApiStatus';
import { AlertService } from '@src/api/common/AlertService';
import { useRecordScope } from '@src/store/common/RecordStore';

export const DetailWrapperController = (data: any) => {
  const [isDeleted, setIsDeleted] = useState<boolean | null>(null);
  const { HideAlert } = AlertService();
  //TODO: requires higher level implementation/ ref
  const setNotFound = useRecordScope((s) => s.setNotFound);

  useEffect(() => {
    if(data && data.status !== ApiStatus.Success && data.data?.message && data.data?.message.includes('deleted'))
    {
      setIsDeleted(true);
      HideAlert();
      setNotFound(true);
    }
    else{
      setIsDeleted(false);
    }
  }, [data]);

  return { isDeleted }
};